
<template>
<basicContainer>
  <el-row>
    <el-col span="12">
      <avue-form :option="option" v-model="obj" @submit="handleSubmit"></avue-form>
    </el-col>
  </el-row>
</basicContainer>
</template>

<script>
export default {
  data() {
    return {
      obj: {
        dynamic: [{
          key: 'awardPrizeId',
          value: 'none'
        }, {
          key: 'awardGrade',
          value: 'none'
        }, {
          key: 'execution',
          value: 'none'
        }],
        processDefinitionKey: 'scholarShip'
      },
      option: {
        emptyBtn: false,
        submitText: '启动流程',
        labelWidth: 80,
        column: [{
          label: '流程key',
          prop: 'processDefinitionKey',
          span: 12,
          row: true
        },
        {
          label: '参数',
          prop: 'dynamic',
          type: 'dynamic',
          span: 24,
          children: {
            align: 'center',
            column: [{
              label: '参数名',
              prop: 'key'
            }, {
              label: '参数值',
              prop: 'value'
            }]
          }
        }

        ]
      }
    }
  },

  methods: {
    handleSubmit(form = {}, done) {
      let { processDefinitionKey, dynamic } = form
      if (!processDefinitionKey) {
        return this.$message.error('流程key必须填写') && done()
      }
      let query = { processDefinitionKey }
      dynamic.forEach(item => (query[item.key] = item.value))
      this.$router.push({ path: '/startProcess', query })
      done()
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
